import React from "react";
import {
  HiDocumentText,
  HiHome,
  HiUserCircle,
  HiUserGroup,
} from "react-icons/hi2";
import { Link } from "react-router-dom";
import { useUser } from "../../context/contextAPI";

function Sidebar() {
  const { user } = useUser();
  return (
    <>
      <aside
        id="logo-sidebar"
        className="fixed top-0 left-0 z-40 w-64 h-screen pt-24 transition-transform -translate-x-full bg-pink-50 border-r border-gray-200 sm:translate-x-0"
        aria-label="Sidebar"
      >
        <div className="h-full px-3 pb-4 overflow-y-auto bg-pink-50">
          <ul className="space-y-3">
            {/* <li>
              <Link
                to="/utilisateur/dashboard"
                className="poppins-semibold flex items-center p-2 text-gray-900 rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
              >
                <HiHome size={24} />
                <span className="ms-3">Mon compte</span>
              </Link>
            </li> */}
            {user.roles === "Utilisateur" ? (
              <>
                <li>
                  <Link
                    to="/utilisateur/profil"
                    className="poppins-semibold flex items-center p-2 text-gray-900 rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
                  >
                    <HiUserCircle size={24} />
                    <span className="ms-3">Mon profil</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/utilisateur/achats"
                    className="poppins-semibold flex items-center p-2 text-gray-900 rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
                  >
                    <HiDocumentText size={24} />
                    <span className="flex-1 ms-3 whitespace-nowrap">
                      Mes achats
                    </span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/utilisateur/parrainage"
                    className="poppins-semibold flex items-center p-2 text-gray-900 rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
                  >
                    <HiUserGroup size={24} />
                    <span className="flex-1 ms-3 whitespace-nowrap">
                      Parrainage
                    </span>
                  </Link>
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link
                    to="/utilisateur/profil"
                    className="poppins-semibold flex items-center p-2 text-gray-900 rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
                  >
                    <HiUserCircle size={24} />
                    <span className="ms-3">Mon profil</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/utilisateur/subscribe"
                    className="poppins-semibold flex items-center p-2 text-gray-900 rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
                  >
                    <HiUserCircle size={24} />
                    <span className="ms-3">S'abonner</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/utilisateur/liste_utilisateur"
                    className="poppins-semibold flex items-center p-2 text-gray-900 rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
                  >
                    <HiUserCircle size={24} />
                    <span className="ms-3">Liste des utilisateurs</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/utilisateur/transactions"
                    className="poppins-semibold flex items-center p-2 text-gray-900 rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
                  >
                    <HiUserCircle size={24} />
                    <span className="ms-3">Transaction</span>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;
